import React from 'react'
import { ArrowCta, type ArrowCtaProps } from '../ArrowCta'
import classes from './PromoBanner.module.scss'

export const PromoBannerButton = ({
  children,
  kind = 'primary',
  arrowTheme = 'highlighted',
  hideTextOnMobile = false,
  ...rest
}: {
  children: React.ReactNode
  hideTextOnMobile?: boolean
} & ArrowCtaProps) => (
  <ArrowCta
    kind={kind}
    arrowTheme={arrowTheme}
    className={classes.button}
    {...rest}
  >
    <span
      className={
        hideTextOnMobile
          ? 'hidden c-body-bold sm:inline-block'
          : 'inline-block c-body-bold'
      }
    >
      {children}
    </span>
  </ArrowCta>
)
